<template>
	<div class="row">
		<div class="col-6 reports-select" v-for="ty in type" v-on:click="setType(ty.id)">
			<router-link :to="{}" :class="(stype == ty.id) ? 'active' : ''" class="element-box el-tablo">
				{{ t.report_types[ty.key] }}
				<span class="aci">
					<i class="icon-check"></i>
				</span>
			</router-link>
		</div>
		<div class="col-12">

			<div v-if="status > 0">
				<div class="alert alert-danger" v-if="status == 403">
					{{ t.error.access_denied_content }}
				</div>
				<div class="alert alert-danger" v-if="status == 404">
					{{ t.error.notfound_content_list }}
				</div>
			</div>

			<div class="alert alert-success" v-if="Msg">{{ Msg }}</div>
			<div class="alert alert-danger" v-if="errorMsg">{{ errorMsg }}</div>
			<filterGenerator :filter="filter" v-if="stype > 0"></filterGenerator>
		</div>
	</div>
</template>

<script>
    import filterGenerator from '@/components/form/filter'

    export default {
        name: "startReport",
	    components: { filterGenerator },
        data () {
            return {
                t: this.$root.t,
                type: null,
	            filter: null,
	            e: false,
                currencies: [],
                results: [],
                errorMsg: null,
                Msg: null,
	            stype: 0,
	            status: 0

            }
        },
	    watch: {
            'stype' () {
                this.filter.model.type = this.stype;
            }
	    },
	    mounted () {
            this.fetchCurrencies();
		    this.fetchReportType();
	    },
	    methods: {
            setType (t) {
                this.stype = t;
                this.filter.model.type = t;
            },
            filterNow: function() {
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            setFilter () {
	            this.filter = {
                    model: {
                        uid: '',
                        currency: [],
                        multiplier: [],
                        earnings: [],
                        timeRange: [],
	                    errorMsg: null,
	                    type: 0
                    },
                    schema: {
                        groups: [
                            {
                                legend: this.t.filter.title,
                                fields: [
                                    {
                                        type: "input",
                                        inputType: "text",
                                        label: this.t.report_name,
                                        model: "name",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "textArea",
                                        inputType: "text",
                                        label: this.t.report_description,
                                        model: "info",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.finance.currency,
                                        model: "currency",
                                        multi: false,
                                        required: false,
                                        multiSelect: false,
                                        values: this.currencies,
                                        checklistOptions: {
                                            value: "id",
                                            name: "iso_code"
                                        }
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.time_range,
                                        model: "timeRange",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "switch",
                                        label: this.t.show_days,
                                        model: "showDays",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        default: false
                                    },
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.users,
                                        model: "user",
                                        multi: true,
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.create_report,
                                        onSubmit: this.createReport,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            }
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            fetchReportType () {

                this.$http.get(api+'api/v1/get/all_report_types').then(response => {
                    // get body data
	                this.type = response.body.result.type;
	                this.isLoading = false;
	                this.status = response.status;
	            }, response => {
	                this.isLoading = false;
	                this.status = response.status;
	            })
            },
		    async fetchCurrencies () {
		        this.$http.get(api+'api/v1/currencies').then(response => {

		            this.currencies = response.body.result.currencies;
                    this.setFilter();
		        }, response => {

		        })
		    },
		    async createReport () {
		        this.$http.post(api+'api/v1/form/create_report', this.filter.model).then(response => {

		            this.Msg = response.body.msg;

              window.open(api+'api/v1/report/'+response.body.result.id+'.html?access_token='+window.auth.accessToken, '_blank').focus();

			    }, response => {
                    this.errorMsg = response.body.error;
                    this.status = response.status;
			    })

	            setTimeout(()   => {
                    this.Msg = null;
                    this.errorMsg = null;
                }, 3500);
		    },
		    selectedReportClass: function (t) {
		        return (this.stype == t) ? 'active' : '';
		    }
	    }
    }
</script>

<style scoped>
.reports-select a {
	display: relative !important;
}
.reports-select .aci{
	display: none;
	float: right;
	color: #4efd4e;
	font-size: 29px;
	padding-right: 20px;
}
.reports-select .active .aci{
	display: block
}
</style>



// WEBPACK FOOTER //
// src/components/reports/startReport.vue